import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route } from "react-router-dom";

import { DELIVERY_TYPE, EXPRESS_TYPES } from "../../config/constants";
import { serviceSelectPropositionRecord } from "../../config/redux/configurationsSlice";
import { getNestedValue } from "../../utils/helperFunctions";
import { isArrayValid, isNull, isUndefined } from "../../utils/DataUtils";

import Express from "./Express/Express";
import StandardService from "./Standard/Standard";
import DefaultService from "../ServiceAndSlots/DefaultService/DefaultService";
import ClickAndCollect from "./ClickAndCollect/ClickAndCollect";

const ServiceAndSlots = () => {
  const servicePropositionList = useSelector(serviceSelectPropositionRecord);

  /**
   * STANDARD is SLOT_BASED
   * Water is SLOT_BASED
   *
   * DEFAULT is DAY_BASED
   *
   * CLICK_N_COLLECT is Click And Collect
   *
   * FBC is Fulfilled By Carrefour
   *
   * Express is MINUTE_BASED
   * Quick Commerce is MINUTE_BASED
   * Bulk is MINUTE_BASED
   */

  const getRenderedComponent = (serviceObj) => {
    let deliveryType = getNestedValue(serviceObj, "deliveryType");
    if (isNull(deliveryType)) {
      deliveryType = getNestedValue(serviceObj, "name");
    }

    switch (deliveryType) {
      case DELIVERY_TYPE.SLOT_BASED:
        console.log("Rendering Standard service");
        return <StandardService serviceTypeId={serviceObj.id} serviceTypeName={serviceObj.name.toLowerCase()} displayName={serviceObj?.displayName || ""} />;
      case DELIVERY_TYPE.MINUTE_BASED:
        console.log("Rendering Express service");
        return <Express serviceTypeId={serviceObj.id} serviceTypeName={serviceObj.name.toLowerCase()} expressType={EXPRESS_TYPES.ON_DEMAND.value} displayName={serviceObj?.displayName || ""} />;
      case DELIVERY_TYPE.CLICK_N_COLLECT:
        console.log("Rendering Click and Collect service");
        return <ClickAndCollect serviceTypeId={serviceObj.id} serviceTypeName={serviceObj.name.toLowerCase()} displayName={serviceObj?.displayName || ""} />;
      case DELIVERY_TYPE.DAY_BASED:
        console.log("Rendering Default service");
        return <DefaultService serviceTypeId={serviceObj.id} serviceTypeName={serviceObj.name.toLowerCase()} isPOSMappingAreaBased={false} displayName={serviceObj?.displayName || ""} />;
      default:
        console.warn("Unknown delivery type:", deliveryType, "for service:", serviceObj);
        // Attempt to find a matching component based on name
        if (serviceObj?.name?.toLowerCase().includes("standard")) {
          return <StandardService serviceTypeId={serviceObj.id} serviceTypeName={serviceObj.name.toLowerCase()} displayName={serviceObj?.displayName || ""} />;
        } else if (serviceObj?.name?.toLowerCase().includes("express")) {
          return <Express serviceTypeId={serviceObj.id} serviceTypeName={serviceObj.name.toLowerCase()} expressType={EXPRESS_TYPES.ON_DEMAND.value} displayName={serviceObj?.displayName || ""} />;
        }
        return <div>Unknown service type: {serviceObj.name || "No name provided"}</div>;
    }
  };

  return (
    <Routes>
      {!isUndefined(servicePropositionList) && isArrayValid(servicePropositionList) ? (
        <>
          {/* Map service routes */}
          {servicePropositionList.map((serviceObj) => {
            const serviceNameLower = getNestedValue(serviceObj, "name", "").toLowerCase();
            const routePath = `${serviceNameLower}/:posNo?`;
            return (
              <Route key={serviceObj.id} path={routePath} element={getRenderedComponent(serviceObj)} />
            );
          })}

          {/* Root route for service-and-slots */}
          <Route path="" element={
            <div>
              <h2>Please select a service from the sidebar</h2>
              <p>Available services: {servicePropositionList.map(service => service?.displayName || service?.name).join(', ')}</p>
            </div>
          } />

          {/* Catch-all route for unknown services */}
          <Route path="*" element={<div>Service not found. Please select a valid service from the sidebar.</div>} />
        </>
      ) : (
        <Route path="*" element={<div>No services available. Please check if services are configured correctly.</div>} />

      )}
    </Routes>
  );
};

export default React.memo(ServiceAndSlots);
